module.exports = __webpack_public_path__ + "static/media/promotionBlackFriday.ef36901d.gif";